module.exports = __webpack_public_path__ + "h5/img/dh20.7733f115.png";